import Head from 'next/head'
import Script from 'next/script'
import Image from 'next/image'
import { s3Static } from '../../../utils/constants'
import { contentDate, reviewedIso } from '../../../utils/article-date-time'
import { BlogsList } from '../../../components/blogs/BlogList'
import { blogsMaster } from '../../../utils/sg-blogs-data'
import { getRequestJSON } from '../../../api/index/location-api'
import { useState } from 'react'
import { RequestProvider } from '../../../context/RequestContext'
import { AirconRepair } from '../../../components/index/service-category/aircon-service/AirconRepair'
import { Services } from '../../../components/index/service/Services'
import { BottomButtons } from '../../../components/index/service-category/aircon-service/BottomButtons'
import { getWpNewPostsByCategory, getWpPostsByCategory } from '../../../lib/service'
import { getWpHvacServices, getWpNewHvacServices, setWpHvacServices, setWpNewHvacServices } from '../../../service/wp-blogs-store'

// When this page's content last actually changed. Bump it by hand when you
// edit the copy - not for layout/UX changes. Feeds dateModified and
// article:modified_time (see reviewedIso in utils/article-date-time).
const CONTENT_REVIEWED = '2026-10-25'

export async function getStaticProps() {
    let lat = 1.3521
    let lng = 103.8198
    const { month, year } = contentDate(CONTENT_REVIEWED);
    const modifiedDate = reviewedIso(CONTENT_REVIEWED);
    const airconBlogs = blogsMaster['hvac-services'].blogArray;
    const wpPosts = getWpHvacServices().length > 0 ?  getWpHvacServices() : await getWpPostsByCategory(6, "hvac-services");
    setWpHvacServices(wpPosts)
    const wpNewPosts = getWpNewHvacServices().length > 0 ?  getWpNewHvacServices() : await getWpNewPostsByCategory(6, "hvac-services");
    setWpNewHvacServices(wpNewPosts)

    const allRequestCategorySettings = await getRequestJSON("Singapore")
    const requestCategorySettings = allRequestCategorySettings.filter(category => category.requestType === "Aircon Services")

  return {
      props: {
        requestCategorySettings,
        modifiedDate,
        month,
        year,
        airconBlogs,
        wpNewPosts,
        wpPosts
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
      revalidate: 259200, // In seconds
  }
}

export default function Home(props) {
    const countryName = "Singapore"
    const requestType = "Aircon Services"

    const [ requestForm, setRequestForm ] = useState(false)
    const [ isQuickBook, setIsQuickBook ] = useState(false)
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const airconBlogs = props.airconBlogs
    const requestCategorySettings = props.requestCategorySettings
    const wpPosts = props.wpPosts
    const wpNewPosts = props.wpNewPosts  

    const maxRating = [1, 2, 3, 4, 5]

  return (
    <>
      <Head>
        <title>Top 5 Reasons For Aircon Overheating</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content="Is your air conditioner over heating? We bring you a run down of the most common reasons and how to fix them."/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/sg/aircon-servicing-singapore/aircon-overheating" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={`Top 5 Reasons For Aircon Overheating`}/>
        <meta property="og:description" content="Is your air conditioner over heating? We bring you a run down of the most common reasons and how to fix them." />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-27T07:30:46+00:00" />
        <meta property="article:modified_time" content={modifiedDate} />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/living/dirty-aircon.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/living/dirty-aircon.jpg" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/sg/aircon-servicing-singapore/aircon-overheating"/>
        <meta name="twitter:title" content={`Top 5 Reasons For Aircon Overheating`}/> 
        <meta name="twitter:description" content="Is your air conditioner over heating? We bring you a run down of the most common reasons and how to fix them."/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://www.stringssg.com/sg/aircon-servicing-singapore/aircon-overheating"/>
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html:
            `{"@context":"https://schema.org","@graph":[{"@context":"https://schema.org/","@type":"BlogPosting","mainEntityOfPage":{"@type":"WebPage","@id":"https://www.stringssg.com/sg/aircon-servicing-singapore/aircon-overheating"},"headline":"Common Reasons For Aircon Not Cooling","description":"Is your air conditioner not cooling? Find out the most common reasons and how to fix them.","image":["https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/living/dirty-aircon.jpg"],"author":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/"},"publisher":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/","logo":{"@type":"ImageObject","url":"https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/logo.png"}},"datePublished":"2025-01-27T07:30:46+00:00","dateModified":"${modifiedDate}"},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"item":{"@type":"WebPage","@id":"https://www.stringssg.com/","name":"Home","url":"https://www.stringssg.com/"}},{"@type":"ListItem","position":2,"item":{"@type":"WebPage","@id":"https://www.stringssg.com/sg/aircon-servicing-singapore","name":"Aircon Servicing Singapore","url":"https://www.stringssg.com/sg/aircon-servicing-singapore"}},{"@type":"ListItem","position":3,"item":{"@type":"WebPage","@id":"https://www.stringssg.com/sg/aircon-servicing-singapore/aircon-overheating","name":"Aircon Overheating","url":"https://www.stringssg.com/sg/aircon-servicing-singapore/aircon-overheating"}}]}]}`
          }}
        />
        </Head>
        <div>
            {/* Hero H1 lives in AirconRepair; the body heading below is an H2. This
                replaced AirconServiceRequestForm, which auto-opened the question
                wizard on page load. */}
            <RequestProvider>
                <section id="aircon-overheating" className='relative'>
                    <AirconRepair
                        setRequestForm={setRequestForm}
                        setIsQuickBook={setIsQuickBook}
                        title="Top 5 Reasons Why Your Air Conditioner Is Overheating"
                        problem="Aircon overheating"
                        heroImage="blog/living/dirty-aircon.jpg"
                    />
                </section>
                {!requestForm &&
                    <BottomButtons countryName={countryName}/>
                }
                {requestForm &&
                    <Services
                        requestType={requestType}
                        requestCategorySettings={requestCategorySettings}
                        setRequestForm={setRequestForm}
                        isQuickBook={isQuickBook}
                        isCustomBook={false}
                        asSheet
                    />
                }
            </RequestProvider>
            <div className='max-w-5xl mx-auto py-5 px-2 leading-8'>
                <div className='space-y-2'>
                    <h2 className='text-xl md:text-2xl text-center uppercase'><strong>Top 5 Reasons Why Your Air Conditioner Is Overheating</strong></h2>
                    <div className='text-gray-400 text-xs text-center'>
                        <time dateTime={modifiedDate}>Updated - {new Date(modifiedDate).toUTCString().substring(0,16)}</time>
                    </div>
                    <p className='py-5'>
                        Our air conditioners are our best friends in providing a cool and comfortable indoor environment during the hot summer months.
                        However, like any other appliance, air conditioners are not immune to problems, and one of the most common issues they face is overheating. 
                        In this article, we will explore the top reasons why air conditioners overheat and what you can do to prevent and address these issues.
                    </p>
                    <div className='relative h-96 my-2'>
                        <Image className='rounded-lg'
                            src={s3Static + "blog/living/dirty-aircon.jpg"}
                            fill
                            style={{objectFit: 'cover'}}
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt='aircon is overheating'
                        />          
                    </div>
                    <figcaption className='text-xs italic text-center'>Dirty aircon coil resulting in extreme overheating</figcaption>
                </div>
                <div className='py-2 space-y-5'>  
                    <div>
                        <h3 className='font-bold pt-3 text-xl'>1. Long Hours of Running</h3>
                        <p>
                            Your aircon might be running for over 24 hours which can result in overheating. Do give it a break to to cool it down.
                        </p>
                    </div>
                    <div>
                        <h3 className='font-bold pt-3 text-xl'>2. Low Refrigerant</h3>
                        <p>
                            Low refrigerant levels cause the aircon to not function optimally, which can result in overheating. When the refrigerant level is too low or there is a leak 
                            in the system, your AC may struggle to remove heat from your home effectively. This extra strain can cause the compressor to overheat. 
                            If you have recently filled the refrigerant gas then possibly there might be a leakage which needs to be fixed by professional service.
                        </p>
                        <div className='relative h-80 max-w-md my-2'>
                            <Image className='rounded-lg'
                                src={s3Static + "blog/living/aircon-gas.jpg"}
                                fill
                                sizes="(max-width: 768px) 100vw, 33vw"
                                style={{objectFit: 'contain'}}
                                placeholder='blur'
                                blurDataURL={s3Static + "placeholder.png"}
                                alt='aircon refrigerant'
                            />          
                        </div>
                    </div>
                    <div>
                        <h3 className='font-bold pt-3 text-xl'>3. Condenser Placement</h3>
                        <p>
                            The condenser must be placed outside your house in an open area, for the heat to be released to the atmosphere. Placing the condenser in a 
                            congested area can often cause overheating because the heat from condenser is not released efficiently.
                        </p>
                        <div className='relative h-80 max-w-md my-2'>
                            <Image className='rounded-lg'
                                src={s3Static + "blog/living/aircon-condenser.jpg"}
                                fill
                                sizes="(max-width: 768px) 100vw, 33vw"
                                style={{objectFit: 'contain'}}
                                placeholder='blur'
                                blurDataURL={s3Static + "placeholder.png"}
                                alt='aircon condenser'
                            />          
                        </div>
                    </div>
                    <div>
                        <h3 className='font-bold pt-3 text-xl'>4. Bad Or Dirty Air Filters</h3>
                        <p>
                            One of the most common reasons for air conditioner overheating is dirty or clogged filters. Air filters are responsible for trapping dust, dirt, and other 
                            particles, preventing them from entering the system. When filters become clogged, they restrict airflow, causing the air conditioner to work harder to cool 
                            the room. This increased workload can lead to overheating. Regularly cleaning or replacing air filters is essential to maintain proper airflow and prevent 
                            overheating.
                        </p>
                        <div className='relative h-72 max-w-md my-2'>
                            <Image className='rounded-lg'
                                src={s3Static + "blog/living/airocn-filter.jpg"}
                                fill
                                sizes="(max-width: 768px) 100vw, 33vw"
                                style={{objectFit: 'contain'}}
                                placeholder='blur'
                                blurDataURL={s3Static + "placeholder.png"}
                                alt='aircon filter'
                            />          
                        </div>
                    </div>
                    <div>
                        <h3 className='font-bold pt-3 text-xl'>5. Clogged Or Broken Evaporator Coils</h3>
                        <p>
                            The condenser coils in your outdoor unit are responsible for releasing heat absorbed from your home. When these coils become covered in dirt, 
                            debris, or vegetation, they can&apos;t effectively release heat, causing the system to overheat. Regularly cleaning the condenser coils or ensuring there is 
                            proper clearance around the outdoor unit can help prevent this problem.
                        </p>
                        <div className='relative h-72 max-w-md my-2'>
                            <Image className='rounded-lg'
                                src={s3Static + "blog/living/aircon-evaporator.jpg"}
                                fill
                                sizes="(max-width: 768px) 100vw, 33vw"
                                style={{objectFit: 'contain'}}
                                placeholder='blur'
                                blurDataURL={s3Static + "placeholder.png"}
                                alt='aircon evaporator'
                            />          
                        </div>
                    </div>
                </div>  
                <BlogsList blogs={airconBlogs} wpPosts={wpPosts} wpNewPosts={wpNewPosts}/>
            </div>
        </div>
        <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
        />
        <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}
